import { createListCollection, HStack, Portal, Select, Text } from "@chakra-ui/react";
import { useMemo } from "react";

/** Compact labelled dropdown for the Clients toolbar (status / role / sort filters). */
const FilterSelect = ({ label, value, options, onChange, width = "180px" }) => {
    const collection = useMemo(
        () =>
            createListCollection({
                items: options.map((opt) =>
                    typeof opt === "string" ? { value: opt, label: opt } : opt
                ),
            }),
        [options]
    );

    return (
        <Select.Root
            collection={collection}
            value={value ? [value] : []}
            onValueChange={(e) => onChange(e.value[0] ?? value)}
            size="sm"
            width={width}
            flex="0 0 auto"
        >
            <Select.HiddenSelect />
            <Select.Control>
                <Select.Trigger>
                    <HStack gap={1} minW={0} overflow="hidden">
                        <Text color="text.grey" fontSize="sm" flexShrink={0}>{label}:</Text>
                        <Select.ValueText placeholder="All" css={{ color: "white" }} />
                    </HStack>
                </Select.Trigger>
                <Select.IndicatorGroup>
                    <Select.Indicator />
                </Select.IndicatorGroup>
            </Select.Control>
            <Portal>
                <Select.Positioner css={{ "--z-index": "1600 !important" }}>
                    <Select.Content>
                        {collection.items.map((item) => (
                            <Select.Item item={item} key={item.value}>
                                {item.label}
                                <Select.ItemIndicator />
                            </Select.Item>
                        ))}
                    </Select.Content>
                </Select.Positioner>
            </Portal>
        </Select.Root>
    );
};

export default FilterSelect;
